import type { RfBand } from '../model/schema.js';

/** Frequency range of each band (MHz, inclusive). */
export const RF_BAND_RANGES: Readonly<Record<Exclude<RfBand, 'other'>, readonly [number, number]>> =
  {
    vhf: [174, 230],
    uhf_470_608: [470, 608],
    uhf_608_694: [608, 694],
    uhf_694_703: [694, 703],
    uhf_823_832: [823, 832],
    uhf_863_865: [863, 865],
    ghz_1_8: [1785, 1805],
    ghz_2_4: [2400, 2483.5],
  };

/** The band a frequency (MHz) lies in, `other` outside all of them. */
export function bandOf(frequency: number): RfBand {
  for (const [band, [lo, hi]] of Object.entries(RF_BAND_RANGES)) {
    if (frequency >= lo && frequency <= hi) return band as RfBand;
  }
  return 'other';
}

/** False only when both are known and the frequency lies outside the band. */
export function frequencyFitsBand(
  band: RfBand | undefined,
  frequency: number | undefined,
): boolean {
  if (band === undefined || frequency === undefined || band === 'other') return true;
  const [lo, hi] = RF_BAND_RANGES[band];
  return frequency >= lo && frequency <= hi;
}
